import { render, staticRenderFns } from "./PresidentialElec2026ColGraph.vue?vue&type=template&id=c5db1dba&"
import script from "./PresidentialElec2026ColGraph.vue?vue&type=script&lang=js&"
export * from "./PresidentialElec2026ColGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5db1dba')) {
      api.createRecord('c5db1dba', component.options)
    } else {
      api.reload('c5db1dba', component.options)
    }
    module.hot.accept("./PresidentialElec2026ColGraph.vue?vue&type=template&id=c5db1dba&", function () {
      api.rerender('c5db1dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/presidential-elec2026-colgraph/PresidentialElec2026ColGraph.vue"
export default component.exports